export const addressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  CONTACT: 'CONTACT',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}
